var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.5"},[React.createElement("rect",{"x":"11","width":"2","height":"24","fill":"currentColor","key":0}),React.createElement("rect",{"x":"24","y":"11","width":"2","height":"24","transform":"rotate(90 24 11)","fill":"currentColor","key":1})]));
}

Add.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Add;

Add.default = Add;
